import { CheckCircle2, Download, Plus, Send } from "lucide-react";
import React, { useMemo, useState } from "react";
import { Button } from "../button";
import { formatPriceNOK } from "../../../utilities/conversions";
import Badge from "../badge";
import { InvoiceModal } from "./invoicemodal";

export default function Invoices({ baseUrl }: { baseUrl: string }) {

    const initialInvoices = [
        { id: "INV-1043", date: "2025-05-04", customer: "Nordic Elektro AS", amount: 14500, vat: 25, status: "Pending" },
        { id: "INV-1042", date: "2025-05-02", customer: "Hjem & Hage DA", amount: 8200, vat: 25, status: "Paid" },
        { id: "INV-1041", date: "2025-04-28", customer: "Trygg Regnskap", amount: 3600, vat: 25, status: "Overdue" },
    ];

    const [invoices, setInvoices] = useState(initialInvoices);

    const kpi = useMemo(() => {
        const totalPaid = invoices.filter(i => i.status === "Paid").reduce((a, b) => a + b.amount, 0);
        const outstanding = invoices.filter(i => i.status !== "Paid").reduce((a, b) => a + b.amount, 0);
        return {
            appointmentsToday: 3,
            awaitingPayout: 1299,
            paidOut: 899,
            callsThisMonth: 48,
            avgCallMinutes: 17,
            totalRevenue: totalPaid + outstanding,
            outstanding,
            paidToday: 2150,
        };
    }, [invoices]);

    // New invoice form state
    const [form, setForm] = useState({
        customer: "",
        email: "",
        org: "",
        description: "",
        qty: 1,
        unitPrice: 1000,
        vat: 25,
        dueDays: 14,
        fastpris: false,
    });

    const [show, setShow] = useState(false);


    return (
        <>
            <div className="grid grid-cols-[1fr_auto_auto] gap-2 mb-3 mr-auto">
                <h3 className="font-bold text-purple-900">Faktura</h3>
                <Button onClick={() => setShow(true)} className="bg-gradient-to-r from-purple-600 to-violet-600"><Plus className="mr-2 h-4 w-4" />Ny faktura</Button>
            </div>
            <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="rounded-lg border p-3">
                    <div className="text-slate-600">Fakturaer sendt</div>
                    <div className="mt-1 text-2xl font-bold">{invoices.length}</div>
                </div>
                <div className="rounded-lg border p-3">
                    <div className="text-slate-600">Utestående</div>
                    <div className="mt-1 text-2xl font-bold">{formatPriceNOK(kpi.outstanding)}</div>
                </div>
            </div>
            <div className="grid text-sm mt-4">
                <div className="text-sm font-medium mb-2">Siste fakturaer</div>
                <div className="overflow-hidden rounded-xl border">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50 text-slate-600">
                            <tr>
                                <th className="px-3 py-2 text-left">#</th>
                                <th className="px-3 py-2 text-left">Dato</th>
                                <th className="px-3 py-2 text-left">Kunde</th>
                                <th className="px-3 py-2 text-right">Beløp</th>
                                <th className="px-3 py-2 text-left">Status</th>
                                <th className="px-3 py-2 text-right">Handlinger</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.map((inv) => (
                                <tr key={inv.id} className="border-t">
                                    <td className="px-3 py-2">{inv.id}</td>
                                    <td className="px-3 py-2">{inv.date}</td>
                                    <td className="px-3 py-2">{inv.customer}</td>
                                    <td className="px-3 py-2 text-right">{formatPriceNOK(inv.amount)}</td>
                                    <td className="px-3 py-2">
                                        {inv.status === "Paid" ? (
                                            <Badge className="bg-emerald-100 text-emerald-700 border border-emerald-200"><CheckCircle2 className="mr-1 h-3 w-3" />Betalt</Badge>
                                        ) : inv.status === "Overdue" ? (
                                            <Badge className="bg-rose-100 text-rose-700 border border-rose-200">Forfalt</Badge>
                                        ) : (
                                            <Badge variant="secondary">Venter</Badge>
                                        )}
                                    </td>
                                    <td className="px-3 py-2 text-right">
                                        <div className="flex items-center justify-end gap-2">
                                            <Button><Download className="mr-1 h-4 w-4" />PDF</Button>
                                            <Button><Send className="mr-1 h-4 w-4" />Send</Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div >
            <InvoiceModal
                show={show}
                onClose={() => setShow(false)}
                baseUrl={baseUrl}
                form={form}
                setForm={setForm}
            />
        </>
    )
}